var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26C20.8589 27.1483 21.9547 28.0984 23.2131 28.7859C24.4715 29.4734 25.863 29.8822 27.2933 29.9847C28.7236 30.0871 30.1592 29.8807 31.5027 29.3796C32.8462 28.8784 34.0662 28.0941 35.08 27.08L41.08 21.08C42.9016 19.194 43.9095 16.668 43.8867 14.046C43.864 11.424 42.8123 8.9159 40.9582 7.06181C39.1041 5.20773 36.596 4.15604 33.974 4.13326C31.352 4.11048 28.826 5.11842 26.94 6.94L23.5 10.36M28 22C27.1411 20.8517 26.0453 19.9016 24.7869 19.2141C23.5285 18.5266 22.137 18.1178 20.7067 18.0153C19.2764 17.9129 17.8408 18.1193 16.4973 18.6204C15.1538 19.1216 13.9338 19.9059 12.92 20.92L6.92 26.92C5.09842 28.806 4.09048 31.332 4.11326 33.954C4.13604 36.576 5.18773 39.0841 7.04181 40.9382C8.8959 42.7923 11.404 43.844 14.026 43.8667C16.648 43.8895 19.174 42.8816 21.06 41.06L24.48 37.64",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink03);
export default __webpack_public_path__ + "static/media/link-03.deccf0f885e34bf3785209c457f387df.svg";
export { ForwardRef as ReactComponent };